import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import Sidebar from "../layout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  changeUserPassword,
  editProfileData,
  fetchUserData,
} from "../../redux/features/accountSlice";
import { useTranslation } from "react-i18next";

const Account = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.account);
  const [successMessage, setSuccessMessage] = useState("");

  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
  });

  const [passwordData, setPasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setUserData({
        first_name: profile.first_name || "",
        last_name: profile.last_name || "",
        email: profile.email || "",
        mobile: profile.mobile || "",
      });
    }
  }, [profile]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "mobile" && !/^\d*$/.test(value)) return;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      dispatch(editProfileData(userData));
      setSuccessMessage("Profile updated successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setPasswordData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordData.new_password !== passwordData.confirm_password) {
      alert("New password and confirm password do not match!");
      return;
    }
    try {
      dispatch(
        changeUserPassword({
          current_password: passwordData.current_password,
          new_password: passwordData.new_password,
        })
      );
      setPasswordData({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
      setSuccessMessage("Password changed successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    } catch (error) {
      console.error("Error changing password:", error);
    }
  };

  return (
    <section className="pt-5 pb-5 bg-light min-vh-100">
      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-3 mb-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-9">
            {/* Profile Section */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-body bg-white p-4">
                <h4 className="fw-semibold text-dark mb-3">{`${t('Account_Details')}`}</h4>
                <p className="text-muted mb-4">
                  {`${t('Manage_your_personal')}`}
                </p>

                {successMessage && (
                  <div className="alert alert-success">{successMessage}</div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="first_name" className="form-label fw-semibold">
                        {`${t('First_Name')}`}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="first_name"
                        name="first_name"
                        placeholder={`${t("Enter_First_Name")}`}
                        value={userData.first_name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="last_name" className="form-label fw-semibold">
                        {`${t('Last_Name')}`}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="last_name"
                        name="last_name"
                        placeholder={`${t("Enter_Last_Name")}`}
                        value={userData.last_name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="mobile" className="form-label fw-semibold">
                        {`${t('Phone')}`}
                      </label>
                      <PhoneInput
                        country={"in"}
                        value={userData.mobile}
                        onChange={(phone) =>
                          setUserData((prev) => ({ ...prev, mobile: phone }))
                        }
                        inputStyle={{
                          width: "100%",
                          height: "42px",
                          borderRadius: "8px",
                        }}
                        buttonStyle={{
                          borderRadius: "8px 0 0 8px",
                        }}
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label fw-semibold">
                        {`${t('Email')}`}
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={userData.email}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <button type="submit" className="btn btn-primary px-4 py-2">
                      {t("Save_Changes")}
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Password Section */}
            <div className="card border-0 shadow-sm rounded-4">
              <div className="card-body bg-white p-4">
                <h4 className="fw-semibold text-dark mb-3">{`${t('Change_Password')}`}</h4>
                <p className="text-muted mb-4">
                  {`${t('Update_your_password')}`}
                </p>

                {successMessage && (
                  <div className="alert alert-success">{successMessage}</div>
                )}

                <form onSubmit={handlePasswordSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label
                        htmlFor="current_password"
                        className="form-label fw-semibold"
                      >
                        {`${t('Current_Password')}`}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="current_password"
                        name="current_password"
                        placeholder={`${t("Enter_current_password")}`}
                        value={passwordData.current_password}
                        onChange={handlePasswordChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label
                        htmlFor="new_password"
                        className="form-label fw-semibold"
                      >
                        {`${t('New_Password')}`}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="new_password"
                        name="new_password"
                        placeholder={`${t("Enter_New_Password")}`}
                        value={passwordData.new_password}
                        onChange={handlePasswordChange}
                      />
                    </div>

                    <div className="col-md-6">
                      <label
                        htmlFor="confirm_password"
                        className="form-label fw-semibold"
                      >
                        {`${t('Confirm_Password')}`}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirm_password"
                        name="confirm_password"
                        placeholder={`${t("Enter_Confirm_Password")}`}
                        value={passwordData.confirm_password}
                        onChange={handlePasswordChange}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <button type="submit" className="btn btn-outline-primary px-4 py-2">
                      {t("Change_Password")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Account;
